/* eslint-disable no-console */
import { ToastProgrammatic as Toast } from 'buefy'
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
      Toast.open('Se ha realizado una actualización importante!... actualizando')
      caches.keys().then(function (names) {
        for (let name of names)
          caches.delete(name);
      });
      window.location.reload();
    },
    updated() {
      console.log('New content is available; please refresh.')
      // Toast.open('Se ha realizado una actualización importante!')
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
